import * as React from 'react';

import classNames from 'classnames';
import type { IColorModifier } from '../ColorHelper';
import { getColorModifierClasses } from '../ColorHelper';

export interface ITextProps extends IColorModifier {
	size?: number;
	isHidden?: boolean;
}

export default class Text extends React.Component<ITextProps, {}> {
	public render() {
		const { isHidden, size } = this.props;

		if (isHidden) {
			return null;
		}

		const classes = classNames(
			size && `is-size-${size}`,
			getColorModifierClasses(this.props)
		);

		return <span className={classes}>{this.props.children}</span>;
	}
}
